module.exports = __webpack_public_path__ + "static/media/WarningSign.ebda0d34.svg";